var exports = {
  "kL": "x2b2fbebb--a8d25f--container",
  "Qs": "x2b2fbebb--a8d25f--content",
  "wx": "x2b2fbebb--a8d25f--header",
  "Qq": "x2b2fbebb--a8d25f--text",
  "XI": "x2b2fbebb--a8d25f--action",
};

module.exports = exports;
